/**
 *  interface for Login Type
*/
export enum ProfileTypes {
    GET_PROFILE = '@@profile/GET_PROFILE',
    GET_PROFILE_SUCCESS = '@@profile/GET_PROFILE_SUCCESS',
    EDIT_PROFILE = '@@profile/EDIT_PROFILE',
    PROFILE_SUCCESS = '@@profile/PROFILE_SUCCESS',
    PROFILE_ERROR = '@@profile/PROFILE_ERROR',
    RESET_PROFILE_FLAG = '@@profile/RESET_PROFILE_FLAG',
}
